export interface ShareMessageInput {
  occasionType?: string | null;
  eventName?: string | null;
  hostName?: string | null;
  customData?: any;
}

/**
 * Generate a contextually rich, beautiful sharing message for WhatsApp/Facebook/etc.
 * dynamically resolving names, event types, and emojis.
 */
export function generateShareMessage(invitation: ShareMessageInput, link: string): string {
  const occasion = invitation.occasionType;
  const eventName = invitation.eventName || 'Event';
  const hostName = invitation.hostName || '';
  const customData = invitation.customData || {};

  let emoji = '🎉';
  let message = '';

  if (occasion === 'WEDDING') {
    emoji = '💍';
    const groom = customData?.wedding?.groom?.fullName || customData?.wedding?.groom?.nickname;
    const bride = customData?.wedding?.bride?.fullName || customData?.wedding?.bride?.nickname;
    const couple = (groom && bride) ? `${groom} & ${bride}` : eventName;
    message = `${emoji} You are warmly invited to celebrate the wedding of ${couple}.`;
  } else if (occasion === 'ENGAGEMENT') {
    emoji = '💍';
    const groom = customData?.wedding?.groom?.fullName || customData?.wedding?.groom?.nickname;
    const bride = customData?.wedding?.bride?.fullName || customData?.wedding?.bride?.nickname;
    const couple = (groom && bride) ? `${groom} & ${bride}` : eventName;
    message = `${emoji} You are warmly invited to celebrate the engagement of ${couple}.`;
  } else if (occasion === 'ANNIVERSARY') {
    emoji = '✨';
    const groom = customData?.wedding?.groom?.fullName || customData?.wedding?.groom?.nickname;
    const bride = customData?.wedding?.bride?.fullName || customData?.wedding?.bride?.nickname;
    const couple = (groom && bride) ? `${groom} & ${bride}` : eventName;
    message = `${emoji} You are warmly invited to celebrate the anniversary of ${couple}.`;
  } else if (occasion === 'BIRTHDAY') {
    emoji = '🎂';
    const birthdayPerson = customData?.birthday?.birthdayPersonName;
    if (birthdayPerson) {
      message = `${emoji} You are warmly invited to celebrate ${birthdayPerson}'s Birthday.`;
    } else {
      message = `${emoji} You are warmly invited to celebrate: ${eventName}.`;
    }
  } else if (occasion === 'BABY_SHOWER') {
    emoji = '👶';
    message = `${emoji} You are warmly invited to celebrate: ${eventName}.`;
  } else if (occasion === 'SEND_OFF') {
    emoji = '✈️';
    message = `${emoji} You are warmly invited to: ${eventName}.`;
  } else {
    // CUSTOM or other
    message = `${emoji} You are warmly invited to celebrate: ${eventName}.`;
  }

  return `${message}\n\nView Invitation:\n${link}\n\nCreated with InviteCloud`;
}
